

export const getBackendTranslation = (
    fallbackTranslation: string,
    backendTranslationsMap: Record<string, string> = {},
    locale: string
  ) => {
    return (
      backendTranslationsMap[locale.replace("-", "_")] || fallbackTranslation
    );
  };

/* Temporary custom function to get fund types for AB, Henning fixes later */

  export const getCustomTranslation = (
    
    fallbackTranslation: string,
    code: string
  ) => {
    const fund_map = new Map();
    fund_map.set('EF', 'Equity');
    fund_map.set('BF', 'Rentefond');
    fund_map.set('MMF', 'Pengemarkedsfond');
    return (
      fund_map.get(code) || fallbackTranslation
    );
  };


  export const getSecuritySubTypeTranslationMapping = (
    code: string | undefined
  ) => {
    const fund_map = new Map();
    fund_map.set('EF',  {
        "fi_FI": "",
        "sv_SE": "",
        "en_US": "",
        "no_NO": "Aksjefond"
    },);
    fund_map.set('BF',  {
        "fi_FI": "",
        "sv_SE": "",
        "en_US": "",
        "no_NO": "Rentefond"

    },);
    fund_map.set('MMF', {
        "fi_FI": "",
        "sv_SE": "",
        "en_US": "",
        "no_NO": "Pengemarkedsfond"

    });
    fund_map.set('HF',{
        "fi_FI": "",
        "sv_SE": "",
        "en_US": "",
        "no_NO": "Hedgefond"

    },);
    return (
      fund_map.get(code) || {
        "fi_FI": "",
        "sv_SE": "",
        "en_US": "",
        "no_NO": ""
      }
    );
  };